/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';

    class TwsTooltipController {
        private viewPath: string;
        private message: string;

        constructor() { }
    }

    class TwsTooltipComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessengerSettings/components/tooltip/twsTooltip.html';
        controller = TwsTooltipController;
        controllerAs = 'tws';
        bindings: any = {
            viewPath: '@?',
            message: '@?'
        };
    }

    angular.module('meevo.plugins.meevoMessengerSettings')
        .component('twsTooltip', new TwsTooltipComponent());
}

